import React, { Component } from 'react';
import ReactSlick from 'react-slick';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { t } from 'ttag';
import ProductLabels from '../../../reusable-components/Labels/ProductLabels';
import * as overlayActions from '../overlayFull/overlayActions';
import * as galleryActions from './galleryActions';
import { addClass } from '../../utils/ie9polyfills';
import arrayToString from '../../../utils/js/arrayToString';
import './slick.less';

class SlickComponentTablet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null,
      activeSlide: 0
    };

    this.slider1 = React.createRef();
    this.slider2 = React.createRef();
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1.current,
      nav2: this.slider2.current
    });

    if (this.slider1 && this.slider1.current.innerSlider) {
      this.slider1.current.innerSlider.list.setAttribute('tabindex', 0);
      this.slider1.current.innerSlider.list.focus();
    }
    this.props.REGISTER_SLIDER('tabletSlider', this.slider1.current);
  }

  handleFirstPicLoaded(i) {
    if (i === 0) {
      const footer = document.getElementById('pdp-footer');
      addClass(footer, 'showFooter');
    }
  }

  stopPropagation(e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }

  render() {
    const BFCondition = window.config.black_friday_ff;
    /**
     * The Discount Percentage, which determines if the Discount Label is shown. (10% or more)
     * @type {string}
     */
    const discountPercentage =
      this.props?.app?.data?.prices?.discount_percentage || '0';
    const {
      images,
      videos,
      // video_file,
      // video_thumbnail,
      title,
      labels
    } = this.props.app.data;
    const { selections } = this.props.app;
    const selectedLabels = selections.sizeDetails
      ? selections.sizeDetails.labels
      : labels;

    const style = {
      position: 'relative',
      height: 0,
      width: '100%',
      paddingBottom: '50.25%',
      marginTop: '30%'
    };
    const { activeSlide } = this.state;
    const totalGalleryLength =
      videos && videos.length > 0
        ? videos.length + images.gallery.length
        : images.gallery.length;

    return (
      <div className="slickComponent tablet">
        <div className="mainSliderHolder" data-testid="product-slider">
          {selectedLabels.length > 0 && (
            <ProductLabels
              labels={selectedLabels}
              discountPercentage={parseInt(discountPercentage, 10)}
              isProductPage
              extraClasses={arrayToString(BFCondition)}
            />
          )}
          <ReactSlick
            className="mainSlider"
            asNavFor={this.state.nav2}
            ref={this.slider1}
            dots={false}
            infinite={false}
            arrows={false}
            speed={200}
            slidesToShow={1}
            afterChange={current => {
              this.setState({ activeSlide: current });
              this.slider2.current.slickGoTo(current);
            }}
            slidesToScroll={1}
            lazyLoad
          >
            {images.gallery.map((item, i) => {
              return (
                <div key={item.thumb}>
                  <img
                    src={item.image}
                    alt={title}
                    onLoad={() => this.handleFirstPicLoaded(i)}
                  />
                </div>
              );
            })}
            {/* {video_file ? (
              <div
                onClick={() => {
                  this.stopPropagation();
                  this.setState({ isLoaded: true });
                }}
                style={{ paddingBottom: '100%', height: 0 }}
                role="button"
                tabIndex="-1"
              >
                <div style={style} className="videoWrapper">
                {this.state.isLoaded ? (
                  // eslint-disable-next-line jsx-a11y/media-has-caption
                  <video
                    title="product video"
                    src={video_file}
                    width={640}
                    height={360}
                    frameBorder={0}
                    style={{
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      left: 0,
                    }}
                    controls
                    autoPlay
                  />
                  )
                :
                (<div />)}
                </div>
              </div>
            )
            :
            (<div />)
          } */}
            {videos && videos.length > 0 && (
              <div
                onClick={this.stopPropagation}
                style={{ paddingBottom: '100%', height: 0, outline: 'none' }}
                role="button"
                tabIndex="0"
              >
                <div style={style} className="videoWrapper">
                  <iframe
                    title="product video"
                    src={videos[0].link}
                    width={640}
                    height={360}
                    frameBorder={0}
                    style={{
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      left: 0
                    }}
                    allowFullScreen
                  />
                </div>
              </div>
            )}
          </ReactSlick>
        </div>
        <div
          className={
            totalGalleryLength > 5
              ? 'thumbSliderHolder'
              : 'thumbSliderHolder noArrows'
          }
          onClick={this.stopPropagation}
          role="button"
          tabIndex="0"
          style={{ outline: 'none' }}
        >
          {totalGalleryLength > 5 && activeSlide !== 0 && (
            <div
              className="arrow arrow-left"
              onClick={() => {
                this.slider1.current.slickPrev();
                this.slider2.current.slickPrev();
              }}
              role="button"
              tabIndex="0"
              style={{ outline: 'none' }}
              aria-label={t`Previous`}
            />
          )}
          <ReactSlick
            className="thumbSlider"
            asNavFor={this.state.nav1}
            ref={this.slider2}
            dots={false}
            infinite={false}
            arrows={false}
            speed={200}
            slidesToShow={5}
            focusOnSelect
            accessibility={false}
            lazyLoad
          >
            {images.gallery.map((item, i) => {
              if (item.thumb !== '') {
                return (
                  <div
                    className={i === activeSlide ? 'thumb active' : 'thumb'}
                    key={item.thumb}
                    onClick={() => {
                      this.slider1.current.slickGoTo(i);
                      this.slider2.current.slickGoTo(i);
                    }}
                    role="button"
                    tabIndex="0"
                    style={{ outline: 'none' }}
                  >
                    <img src={item.thumb} alt={title} />
                    <div>
                      <span className="bar" />
                    </div>
                  </div>
                );
              }
              return null;
            })}
            {/* {video_file ? (
              <div
                id="product-video"
                className={
                activeSlide === images.gallery.length
                ? 'active thumb thumb-video'
                : 'thumb thumb-video'
              }
              >
                {video_thumbnail ? (
                <img
                  className="thumbnail-video"
                  src={video_thumbnail}
                  alt="Product video thumbnail"
                />
                )
                :
                (<div className="v-icon" />)
                }

                <div>
                  <span className="bar" />
                </div>
              </div>
              )
              :
              (<div />)
            } */}
            {videos && videos.length > 0 && (
              <div
                className={
                  activeSlide === images.gallery.length + 1
                    ? 'active thumb thumb-video'
                    : 'thumb thumb-video'
                }
              >
                <div className="v-icon" />
                <div>
                  <span className="bar" />
                </div>
              </div>
            )}
          </ReactSlick>

          {totalGalleryLength > 5 && activeSlide !== totalGalleryLength - 1 && (
            <div
              className="arrow arrow-right"
              onClick={() => {
                this.slider1.current.slickNext();
                this.slider2.current.slickPrev();
              }}
              role="button"
              tabIndex="0"
              style={{ outline: 'none' }}
              aria-label={t`Next`}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ app, general, gallery }) => {
  return { app, general, gallery };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ ...galleryActions, ...overlayActions }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SlickComponentTablet);
